/*
  Логотип Booko для корешка — вектор, повторяющий фирменный знак booko_logo_new.png
  (силуэт раскрытой книги + знак ∞). Контур ∞ взят из assets/booko_logo.svg (wordmark),
  силуэт книги снят с PNG по точкам. Совмещение сверено оверлеем с оригиналом.

  Вектор вместо PNG: в печатный PDF уходит контур, а не растр 214px, и обе части
  красятся напрямую (fill), без масок и CORS.
*/

const SPINE_LOGO_ASPECT = 143 / 214

const BOOK_PATH = [
  'M 0 126 L 0 13',
  'Q 2 7 8 5.5', 'Q 20 3.5 42 1', 'L 72 2.5', 'C 88 3.5 100 7 107 13',
  'C 114 7 126 3.5 142 2.5', 'L 172 1', 'Q 194 3.5 206 5.5', 'Q 212 7 214 13',
  'L 214 126',
  'Q 212 132 206 133', 'Q 194 134.5 189 131', 'L 174 130',
  'C 158 130 148 130.5 143 132', 'C 128 135 114 137 107 142',
  'C 100 137 86 135 71 132', 'C 66 130.5 56 130 40 130',
  'L 25 131', 'Q 20 134.5 8 133', 'Q 2 132 0 126',
  'Z'
].join(' ')

const INFINITY_PATH = 'M173.5,35.1c-5.7-5.6-12.5-8.4-20.2-8.4c-7.1,0-13.5,2.6-19.1,7.7c-0.2,0.2-6.2,5.8-9.9,9.1c-1.6,1.5-17.1,15.4-17.1,15.4l0,0c-3.1,2.8-6.7,6-7,6.2c-3.1,3-6.5,4.5-10.6,4.5s-7.8-1.4-10.9-4.4c-3.1-2.9-4.6-6.2-4.6-10.1c0-4.1,1.5-7.5,4.6-10.5c3.1-3,6.7-4.4,10.9-4.4s7.6,1.4,10.7,4.3c0.3,0.3,3.2,3,6.4,6c0.8,0.8,2.1,0.8,2.9,0l6.6-6c1-0.9,1-2.4,0-3.2c-3.5-3.2-6.8-6.2-6.8-6.3c-5.7-5.6-12.5-8.4-20.2-8.4s-14.2,2.9-19.9,8.5c-5.8,5.7-8.7,12.2-8.7,19.6s2.9,14.4,8.7,20c5.8,5.6,12.7,8.5,20.6,8.5c6.3,0,11.9-2.2,16.9-6.3c0.3-0.3,0.6-0.5,0.9-0.8l13-11.6l12.1-10.9c0,0,8.2-7.6,9.9-9.1c0.2-0.2,0.3-0.3,0.3-0.3c3-2.7,6.4-4,10.5-4s7.6,1.4,10.7,4.3c3,2.9,4.5,6.2,4.5,10.2s-1.5,7.4-4.6,10.4c-3.1,3-6.5,4.5-10.6,4.5s-7.4-1.3-10.5-4.1l-7.2-5.8c-0.8-0.8-2.1-0.8-2.9,0l-6.7,6c-1,0.9-1,2.4,0,3.2c4.3,3.8,9.8,7.9,10.1,8.1c5.1,3.9,11,6,17.6,6c7.4,0,14-2.9,19.6-8.6c5.6-5.7,8.5-12.4,8.5-19.9S179.2,40.7,173.5,35.1L173.5,35.1z'

/* Посадка ∞ внутри знака: bbox контура 60.6,26.6 121.4×56.6 → зона PNG 17,28 176×82. */
const INFINITY_TRANSFORM = 'translate(-70.86 -10.56) scale(1.4498)'

/* SVG-разметка знака: книга в bookColor, знак ∞ в infinityColor. */
function renderSpineLogo (bookColor, infinityColor) {
  return `
    <svg class="spine-logo" viewBox="0 0 214 143" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <path d="${BOOK_PATH}" fill="${bookColor}"/>
      <path d="${INFINITY_PATH}" transform="${INFINITY_TRANSFORM}" fill="${infinityColor}"/>
    </svg>
  `
}

export { renderSpineLogo, SPINE_LOGO_ASPECT }
